/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum KnowledgePathProgressStatus {
    Open = '0',
    Failed = 1,
    Passed = 2,
}
